import React, { ReactElement } from "react";
import Box from "@mui/material/Box";
import { Button, Grid } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { useHistory } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import { useLanguage } from "../../locale/useLanguage";
import "./app.layout.scss";
import MetaTags from "components/MetaTags";
import AppHeaderAdmin from "components/Header";
import { routes } from "routes";

const AppLayout: React.FC<{
  title: string;
  hideOnBack?: boolean;
  children?: ReactElement;
}> = ({ children, title = "", hideOnBack = false }) => {
  const history = useHistory();
  const [t] = useLanguage();

  return (
    <>
      <MetaTags title={title} />
      <CssBaseline />
      <AppHeaderAdmin menu={routes} />
      <Box component="main" className="admin-layout-box-container">
        <Grid
          container
          className="system-page"
          alignContent="start"
          style={{ paddingInline: 0 }}
        >
          {!hideOnBack && (
            <Grid item container xs={12} sx={{ height: "64px" }}>
              <Button
                className="mt-2"
                style={{ fontSize: "1.3rem" }}
                startIcon={<ArrowBack />}
                onClick={() => history.goBack()}
              >
                {t("common.go_back")}
              </Button>
            </Grid>
          )}

          {children}
        </Grid>
      </Box>
    </>
  );
};
export default AppLayout;
